module.exports = __webpack_public_path__ + "media/src/assets/Images/FilterCardArrow-5b3ae21ca009753337e406614da81922.svg";